<div class="w-full flex justify-center slide-wrapper-{{UUID}}"
     [innerHTML]="htmlContent">

</div>
